<template>  
  <div class="x-button"
    @click.prevent="onclick"
    :class="type"
    :style="{width}"
    >
    <div class="l"></div>
    <div class="m">
      <span>{{ text }}</span>
      <slot/>
    </div>
    <div class="r"></div>
  </div> 
</template>

<script>
export default { 
  props: {
    text: {
      type: String,
      default: ''
    },
    type: {
      type: String,
      default: 'b'
    },
    width: {
      type: String,
      default: '200px'
    }
  },
  methods: {
    onclick() {
      this.$emit('click')
    }
  } 
}
</script>
 
<style lang="scss">
.x-button {
  display: flex;
  text-align:center;
  cursor: pointer;
  &.h {
    color: #999;
    height: 36px;
    .l {
      flex: 0 0 auto;
      width: 20px;
      background: url(../assets/button-h/1.png) left center no-repeat;
    }
    .m {
      flex: 1 0 auto;
      background: url(../assets/button-h/3.png) left center repeat-x; 
      line-height: 36px;
    }
    .r {
      flex: 0 0 auto;
      width: 20px;
      background: url(../assets/button-h/2.png) right center no-repeat;
    }
  }
  &.b {
    color: #fff; 
    height: 53px;
    .l {
      flex: 0 0 auto;
      width: 35px;
      background: url(../assets/button-b/1.png) left center no-repeat;
    }
    .m {
      flex: 1 0 auto;
      background: url(../assets/button-b/3.png) left center repeat-x; 
      line-height: 53px;
    }
    .r {
      flex: 0 0 auto;
      width: 40px;
      background: url(../assets/button-b/2.png) right center no-repeat;
    }
  }
  &.mini {
    color: #fff; 
    height: 36px;
    .l {
      flex: 0 0 auto;
      width: 23px;
      background: url(../assets/button-mini/1.png) left center no-repeat;
    }
    .m {
      flex: 1 0 auto;
      background: url(../assets/button-mini/3.png) left center repeat-x; 
      line-height: 40px;
    }
    .r {
      flex: 0 0 auto;
      width: 24px;
      background: url(../assets/button-mini/1.png) right center no-repeat;
       transform: rotate(180deg);
    }
  }
}
</style>